import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

/**
 * Configure NProgress loading bar
 */
export const configureNProgress = () => {
    NProgress.configure({
        // Shows the loading bar at the top
        showSpinner: false,
        
        // Minimum percentage before showing
        minimum: 0.08,
        
        // How much to increment on each tick
        trickleSpeed: 200,
        
        // Auto-increment behavior
        trickle: true,
        
        // Animation easing
        easing: 'ease',
        
        // Animation speed in ms
        speed: 200,
        
        // Parent container (null = document.body)
        parent: 'body',
        
        // Template for the loading bar
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    });
};

// Track active requests
let activeRequests = 0;

/**
 * Start the loading bar
 * Handles multiple concurrent requests
 */
export const startLoading = () => {
    if (activeRequests === 0) {
        NProgress.start();
    }
    activeRequests++;
};

/**
 * Stop the loading bar
 * Only stops when all requests are complete
 */
export const stopLoading = () => {
    if (activeRequests > 0) {
        activeRequests--;
        if (activeRequests === 0) {
            NProgress.done();
        }
    }
};

/**
 * Force stop all loading
 */
export const forceStopLoading = () => {
    activeRequests = 0;
    NProgress.done();
};

/**
 * Set specific progress percentage
 */
export const setProgress = (value: number) => {
    NProgress.set(value);
};

/**
 * Increment progress by specific amount
 */
export const incrementProgress = (amount?: number) => {
    NProgress.inc(amount);
};

// Export NProgress for direct access if needed
export { NProgress };
